import { GridRowId } from '@mui/x-data-grid-pro';
import { TPlaneringRequiredField } from './planeringRequiredValidationUtils';

interface IPlaneringRequiredOnTabRow {
  AKTIVITETSTYP?: string | null;
}

interface IValidatePlaneringRequiredOnTabParams {
  rowId: GridRowId;
  field: string;
  value: unknown;
  row?: IPlaneringRequiredOnTabRow;
  setRequiredFieldError: (
    rowId: GridRowId,
    fieldName: TPlaneringRequiredField,
    message: string
  ) => void;
  clearRequiredFieldError: (
    rowId: GridRowId,
    fieldName: TPlaneringRequiredField
  ) => void;
}

export const PLANERING_REQUIRED_MESSAGES: Record<
  TPlaneringRequiredField,
  string
> = {
  FRANDATUM: 'Fråndatum är obligatoriskt',
  FRANTID: 'Fråntid är obligatoriskt',
  TILLTID: 'Tilltid är obligatoriskt',
  TITEL: 'Titel är obligatoriskt',
  AKTIVITETSTYP: 'Aktivitetstyp är obligatoriskt',
  VERKSAMHETSTYP_ID: 'Verksamhetstyp/Gudstjänsttyp är obligatoriskt',
};

const isEmpty = (value: unknown): boolean =>
  value == null || String(value).trim() === '';

const isAssocRequiredForAktivitetstyp = (
  aktivitetstyp: string | null | undefined
): boolean => aktivitetstyp === 'Gudstjänst' || aktivitetstyp === 'Övrigt';

export const validatePlaneringRequiredOnTab = ({
  rowId,
  field,
  value,
  row,
  setRequiredFieldError,
  clearRequiredFieldError,
}: IValidatePlaneringRequiredOnTabParams): void => {
  const isEmptyValue = isEmpty(value);

  if (field === 'FRANDATUM') {
    if (isEmptyValue) {
      setRequiredFieldError(
        rowId,
        'FRANDATUM',
        PLANERING_REQUIRED_MESSAGES.FRANDATUM
      );
    } else {
      clearRequiredFieldError(rowId, 'FRANDATUM');
    }
  }

  if (field === 'FRANTID') {
    if (isEmptyValue) {
      setRequiredFieldError(
        rowId,
        'FRANTID',
        PLANERING_REQUIRED_MESSAGES.FRANTID
      );
    } else {
      clearRequiredFieldError(rowId, 'FRANTID');
    }
  }

  if (field === 'TILLTID') {
    if (isEmptyValue) {
      setRequiredFieldError(
        rowId,
        'TILLTID',
        PLANERING_REQUIRED_MESSAGES.TILLTID
      );
    } else {
      clearRequiredFieldError(rowId, 'TILLTID');
    }
  }

  if (field === 'TITEL') {
    if (isEmptyValue) {
      setRequiredFieldError(rowId, 'TITEL', PLANERING_REQUIRED_MESSAGES.TITEL);
    } else {
      clearRequiredFieldError(rowId, 'TITEL');
    }
  }

  if (field === 'AKTIVITETSTYP') {
    clearRequiredFieldError(rowId, 'AKTIVITETSTYP');
  }

  const aktivitetstyp =
    field === 'AKTIVITETSTYP' ? String(value ?? '') : row?.AKTIVITETSTYP;
  const isAssocRequired = isAssocRequiredForAktivitetstyp(aktivitetstyp);

  if (field === 'VERKSAMHETSTYP_ID') {
    if (!isAssocRequired) {
      clearRequiredFieldError(rowId, 'VERKSAMHETSTYP_ID');
    } else if (isEmptyValue) {
      setRequiredFieldError(
        rowId,
        'VERKSAMHETSTYP_ID',
        PLANERING_REQUIRED_MESSAGES.VERKSAMHETSTYP_ID
      );
    } else {
      clearRequiredFieldError(rowId, 'VERKSAMHETSTYP_ID');
    }
  }

  if (field === 'AKTIVITETSTYP' && !isAssocRequired) {
    clearRequiredFieldError(rowId, 'VERKSAMHETSTYP_ID');
  }
};
